import { PaymentsItemModel } from "./PaymentsItem.model";
import { ProductPaymentItemModel } from "./ProductPaymentItem.model";
import { ProductsDetail1 } from "./ProductsDetail.model";
import { ShowCurrentStateModal } from "./ShowCurrentState.model";

export class PaymentParentModel {

    newModel: PaymentsItemModel[];
    oldModel: PaymentsItemModel[];
    firstIsPending: boolean;
    oldValidityDate?: number;
    allProducts: ProductsDetail1[];
    currentStateModal: ShowCurrentStateModal;

}
